module.exports = __webpack_public_path__ + "img/terminal.8fa0cbd3.png";